import eventAnalyticsAPI from '../eventAnalytics';

export const treatEvent = async (eventId, customerId, { justification }) => {
  const response = await eventAnalyticsAPI.post(`/customers/${customerId}/events/${eventId}/treatments`, {
    justification
  });

  return response.data;
}
